import { Loader2, Slack } from 'lucide-react'
import { SidebarMenuButton } from '@/components/ui/sidebar'
import {
    NAV_LUCIDE_SIZE_CLASS,
    NAV_LUCIDE_STROKE,
} from '@/components/navigation/navIconConstants'
import { useSlackConnect } from '@/hooks/useSlackConnect'
import { SidebarNavRow } from './SidebarNavRow'
import { cn } from '@/lib/utils'

export function NavSlack() {
    const { connect, isLoading, isDisabled } = useSlackConnect()

    return (
        <SidebarMenuButton
            variant="nav"
            size="nav"
            type="button"
            onClick={connect}
            disabled={isDisabled || isLoading}
            className="truncate"
        >
            <SidebarNavRow
                icon={
                    isLoading ? (
                        <Loader2
                            className={cn(
                                NAV_LUCIDE_SIZE_CLASS,
                                'animate-spin',
                            )}
                            strokeWidth={NAV_LUCIDE_STROKE}
                            aria-hidden
                        />
                    ) : (
                        <Slack
                            className={NAV_LUCIDE_SIZE_CLASS}
                            strokeWidth={NAV_LUCIDE_STROKE}
                            aria-hidden
                        />
                    )
                }
            >
                {isLoading ? 'Connecting...' : 'Connect on Slack'}
            </SidebarNavRow>
        </SidebarMenuButton>
    )
}
